import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'back-navigation',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './back-navigation.component.html',
  styleUrl: './back-navigation.component.scss'
})
export class BackNavigationComponent {
  readonly location = inject(Location);

  // using platformId for checking platform (server / client)
  onClickBack() {
    history.back();
  }
}
